import React from "react"
import { useApolloClient } from "@apollo/client"
import { MentionsInput, Mention } from "react-mentions"
import searchRepsWithClient from "./searchRepsWithClient"
import "./RepMentionsInput.css"

const RepMentionsInput = ({
  value,
  onChange,
  boardId = null,
  className = "text-area",
  placeholder = "",
  renderMentionSuggestion,
  appendSpaceOnAdd = true,
  mentionStyle = undefined,
}) => {
  const apolloClient = useApolloClient()

  const handleSearch = async (search, callback) => {
    const reps = await searchRepsWithClient(
      apolloClient,
      search,
      boardId ? { boardId } : undefined
    )
    callback(reps)
  }

  return (
    <MentionsInput
      value={value}
      onChange={onChange}
      className={className}
      placeholder={placeholder}
      style={mentionStyle}
    >
      <Mention
        trigger="@"
        data={handleSearch}
        displayTransform={(id, display) => `@${display}`}
        appendSpaceOnAdd={appendSpaceOnAdd}
        renderSuggestion={(suggestion, search, highlightedDisplay) =>
          renderMentionSuggestion
            ? renderMentionSuggestion(suggestion, highlightedDisplay)
            : <div>{highlightedDisplay}</div>
        }
      />
    </MentionsInput>
  )
}

export default RepMentionsInput